import React, { useState } from "react";
import '../styles/pageheader.css';
import LeftSideBar from "./LeftSidebar";

const PageHeader = (props) => {
    const [showSideBar, setShowSidebar] = useState(false);
    return (
        <>
            <div className="page-header">
                <i className="las la-angle-left" onClick={() => { window.history.back();}}/>
                <div className="title">
                    { props.title }
                </div>
                <i className="las la-sliders-h" onClick={() => { setShowSidebar(prev => !prev); }} />
            </div>
            <LeftSideBar show={showSideBar} onClose={() => { setShowSidebar(prev => !prev); }}/>
        </>
    )
}
export default PageHeader;